import React from 'react'
import styles from "./Global.module.css";

function MessangerButton() {
  return (
    <></>
  )
}

export default MessangerButton